<template>
    <div class="set-div base-form-div">
        <el-form size="mini" :label-position="labelPosition" label-width="100px" :model="formSet">
            <el-form-item label="飞行模型">
                <el-select v-model="formSet.model">
                    <el-option v-for="(item) in models" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="投影动画">
                <el-select v-model="formSet.animation">
                    <el-option v-for="(item) in animations" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="飞行视角">
                <el-select @change="changeView" v-model="formSet.view">
                    <el-option v-for="(item) in views" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="固定高度(米)">
                <el-input v-model="formSet.height"></el-input>
            </el-form-item>
            <el-form-item label="离地高度(米)">
                <el-input v-model="formSet.addHeight"></el-input>
            </el-form-item>
            <el-form-item label="速度(km/h)">
                <el-input v-model="formSet.speed"></el-input>
            </el-form-item>
            <el-form-item label="飞行倍率">
                <el-input-number :step="0.5" v-model="formSet.scale" controls-position="right" @change="handleChange"
                    :min="0"></el-input-number>
                <!-- <el-input v-model="formSet.scale"></el-input> -->
            </el-form-item>
            <el-form-item label="是否贴地">
                <el-switch @change="surfaceChange" v-model="formSet.surface"></el-switch>
            </el-form-item>
            <el-form-item label="是否循环">
                <el-switch v-model="formSet.cycle"></el-switch>
            </el-form-item>
        </el-form>
        <div class="operate-div">
            <el-button :disabled="start" size="mini" type="primary" @click="setClick">开始</el-button>
            <el-button :disabled="!start || pasuse" size="mini" type="primary" @click="setPause">暂停</el-button>
            <el-button :disabled="!start || !pasuse" size="mini" type="primary" @click="setProceed">继续</el-button>
            <el-button :disabled="!start" size="mini" type="primary" @click="setStop">结束</el-button>
        </div>
    </div>
</template>

<script>
import PathAnimation from "@/utils/cesiumBD/animation/PathAnimation"
import { computeSurfaceLine } from "@/utils/cesiumBD/analysis/utils/index"

let animationUti = undefined;
export default {
    props: ["subData"],
    data() {
        return {
            labelPosition: "left",
            formSet: {
                model: "data/mx/dajiang.gltf",
                surface: true,
                animation: "无",
                view: "无",
                cycle: false,
                height: 0,
                addHeight: 200,
                speed: 40,
                scale: 1
            },
            //
            models: [{
                label: "无",
                value: "无"
            },
            {
                label: "越野车",
                value: "data/mx/GroundVehicle.glb"
            },
            {
                label: "小飞机",
                value: "data/mx/wrj.glb"
            },
            //data/mx/wrj.glb
            {
                label: "无人机",
                value: "data/mx/dajiang.gltf"
            }],
            animations: [{
                label: "无",
                value: "无"
            }, {
                label: "锥体扫描",
                value: "cylinder"
            }],
            views: [
                {
                    label: "无",
                    value: "无"
                }, {
                    label: "跟随视角",
                    value: "gs"
                },
                {
                    label: "第一视角",
                    value: "dy"
                },
                {
                    label: "上帝视角",
                    value: "sd"
                }
            ],
            start: false,
            pasuse: false,
        };
    },

    mounted() {

    },
    beforeDestroy() {
        this.setStop();
    },
    methods: {
        setPause() {
            this.pasuse = true;
            animationUti && animationUti.pause();
        },
        setProceed() {
            this.pasuse = false;
            animationUti && animationUti.proceed();
        },
        setStop() {
            this.start = false;
            this.pasuse = false;
            animationUti && animationUti.stop();
        },
        surfaceChange(val) {
            animationUti && animationUti.setMultiplier(val);
        },
        handleChange(val) {
            animationUti && animationUti.setMultiplier(val);
        },
        changeView(val) {
            animationUti && animationUti.setCameraType(val);
        },
        setClick() {
            if (this.start) {
                return;
            }
            var positions = JSON.parse(this.subData.line);
            computeSurfaceLine({
                scene: viewer.scene,
                positions: positions,
                split: true,
                splitNum: 150,
                has3dtiles: false,
                calback: (raisedPositions, noHeight) => {
                    this.start = true;
                    var positions = raisedPositions;
                    var entity = this.createGLBElement();
                    viewer.entities.add(entity);
                    var animation = new PathAnimation({
                        entity: entity,
                        positions: positions,
                        speed: this.formSet.speed,
                        multiple: this.formSet.scale,
                        height: this.formSet.height,
                        addHeight: this.formSet.addHeight,
                        cameraType: this.formSet.view,
                        shadingType: this.formSet.animation,
                        surface: this.formSet.surface,
                        cycle: this.formSet.cycle,
                    });

                    animation.start();
                    animationUti = animation;
                }
            })
            // this.start = true;
            // var positions = this.subData.linePos;
            // var entity = this.createGLBElement();
            // viewer.entities.add(entity);
            // //DBentityCollection.add(entity);
            // var animation = new PathAnimation({
            //     entity: entity,
            //     positions: positions,
            //     speed: this.formSet.speed,
            //     multiple: this.formSet.scale,
            //     height: this.formSet.height,
            //     addHeight: this.formSet.addHeight,
            //     cameraType: this.formSet.view,
            //     shadingType: this.formSet.animation,
            //     surface: this.formSet.surface,
            //     cycle: this.formSet.cycle,
            // });

            // animation.start();
            // animationUti = animation;

        },
        //构建glb模型
        createGLBElement() {
            var uri = this.formSet.model == "无" ? "data/mx/dajiang.gltf" : this.formSet.model;
            var scale = this.formSet.model == "无" ? 0 : 0.2;
            var minimumPixelSize = this.formSet.model == "无" ? 0.0 : 60;
            var glb = {
                model: {
                    show: true,
                    uri: uri, //模型的地址 
                    scale: scale, //模型缩放比例
                    minimumPixelSize: minimumPixelSize,// 60,
                    maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
                    incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
                    runAnimations: true, // 是否应启动模型中指定的glTF动画
                    clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
                    shadows: Cesium.ShadowMode.ENABLED,
                    heightReference: Cesium.HeightReference.NONE //设置模型贴地,
                }
            }
            return new Cesium.Entity(glb);
        },
    },
};
</script>

<style lang="scss" scoped>
.set-div {
    padding: 0 20px;

    .el-form-item__label {
        color: #fff;
    }
}

.operate-div {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<style lang="scss">
.set-div {
    .el-form-item__label {
        color: #fff;
    }
}
</style>